module.exports = "/_next/static/images/ru_2-a5bca1dccf9005178df5ef36afb9de55.jpg";